module.exports = __webpack_public_path__ + "img/circle.bd667e35.png";